import { render } from "./InquiryConclusions.vue?vue&type=template&id=7dc16bac&scoped=true"
import script from "./InquiryConclusions.vue?vue&type=script&lang=js"
export * from "./InquiryConclusions.vue?vue&type=script&lang=js"

import "./InquiryConclusions.vue?vue&type=style&index=0&id=7dc16bac&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc16bac"]])

export default __exports__